const DetailsSearch = () => {
  return ''
};

export default DetailsSearch;
